<template>
  <section>
    <div class="row mb-2">
      <div class="col-md-6">
        <auto-suggest
          v-model="selected"
          :placeholder="placeholder"
          :filterResults="false"
          :minChars="1"
          :resolveOnLoad="false"
          :delay="750"
          :searchable="true"
          :options="searchHandler"
          trackBy="id"
          :object="true"
        />
      </div>
      <div class="col-md-3" v-if="byRole === null">
        <z-select
          v-model="selectedRole"
          :options="roles"
          :inline="true"
          label="Role"
        />
      </div>
      <div class="col-md-1">
        <button class="btn btn-primary btn-sm" @click="addNewMember">
          Add
        </button>
      </div>
      <div class="col-md-1">
        <!-- <button
          class="btn btn-primary btn-sm"
          :disabled="true"
          @click="inviteMember"
        >
          Invite
        </button> -->
      </div>
      <div class="col-md-1">
        <span class="custom-items-label">{{ numItems }} items</span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 custom-wrapper">
        <z-table
          :value="memberList"
          sortBy="name"
          orderBy="asc"
          :columns="tableColumns"
          :isSingleRowDetail="true"
          @sort="setOrder"
          class="table table-bordered table-striped"
          detailColumnClass="z-column-60-center"
        >
          <template v-slot:tbody="props">
            <th scope="row" class="z-column-80">{{ props.row.id }}</th>
            <td>{{ props.row.name }}</td>
            <td class="z-column-100">{{ props.row.role }}</td>
            <td
              class="z-column-60-center"
              v-if="isFeatureAllowed('member_removal')"
            >
              <a href="#" @click="remove(props.row)">remove</a>
            </td>
          </template>
          <template v-slot:empty> Nothing found! </template>
        </z-table>
      </div>
    </div>
    <confirm-remove
      :show="actionConfirmRemove"
      :confirmTitle="confirmTitleRemove"
      :confirmAction="confirmActionRemove"
      :confirmQuestion="confirmQuestionRemove"
      @closing="closeModal"
      @proceed="performRemove"
    />
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import AutoSuggest from '@vueform/multiselect'
import ZTable from '@/Components/ZElements/Table'
import ZSelect from '@/Components/ZElements/Select'
import ConfirmRemove from '@/Components/ZElements/ConfirmDialog'
export default {
  name: 'organization-members',
  components: {
    AutoSuggest,
    ZTable,
    ZSelect,
    ConfirmRemove,
  },
  props: {
    byRole: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      selected: null,
      selectedRole: null,
      roles: [
        {
          id: 1,
          name: 'User',
          value: 1,
        },
        {
          id: 2,
          name: 'Coach',
          value: 2,
        },
      ],
      itemId: null,
      confirmTitleRemove: 'Confirm Removal',
      confirmActionRemove: 'Remove',
      confirmQuestionRemove: 'Are you sure you wish to remove this Person?',
      actionConfirmRemove: null,
    }
  },
  mounted() {
    this.selected = null
    this.selectedRole = null
    this.loadMembers()
  },
  computed: {
    ...mapGetters('users', ['isFeatureAllowed']),
    ...mapGetters('organizations', ['organization', 'members', 'foundMembers']),
    tableColumns() {
      let _columns = []
      _columns = [
        {
          field: 'id',
          label: 'Id',
          sortable: true,
          class: 'z-column-60-center',
        },
        {
          field: 'name',
          label: 'Name',
          sortable: true,
        },
        {
          field: 'role_id',
          label: 'Role',
          sortable: this.byRole ? false : true,
          class: 'z-column-100',
        },
      ]
      if (this.isFeatureAllowed('member_removal')) {
        _columns.push({
          field: 'id',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
        })
      }
      return _columns
    },
    placeholder() {
      let _data = 'add (type to search)'
      if (this.byRole) {
        if (this.byRole === 1) {
          _data = 'add an existing client member (type to search)'
        } else if (this.byRole === 2) {
          _data = 'add an existing coach (type to search)'
        }
      }
      return _data
    },
    memberList() {
      let _data = []
      if (this.members) {
        _data = this.members
      }
      return _data
    },
    numItems() {
      let _data = 0
      if (this.members) {
        _data = this.members.length
      }
      return _data
    },
  },
  methods: {
    ...mapActions('organizations', [
      'getMembers',
      'sortMembers',
      'findMembers',
      'addMember',
      'removeMember',
    ]),
    showRemoval() {},
    closeModal() {
      this.actionConfirmRemove = null
    },
    setOrder(column, order) {
      let sort = {
        on: column.field,
        dir: order,
      }
      console.log('Sorting Members', sort)
      this.sortMembers(sort)
    },
    async loadMembers() {
      let data = {
        orgid: this.organization.id,
        byRole: this.byRole,
      }
      await this.getMembers(data)
      this.sortMembers('name', 'asc')
    },
    async searchHandler(query) {
      return await this.findMembers(query)
    },
    async addNewMember() {
      let role = this.byRole
      if (role === null) {
        role = parseInt(this.selectedRole)
      }
      if (this.selected && this.selectedRole) {
        let data = {
          orgid: this.organization.id,
          roleid: role,
          userid: this.selected.id,
        }
        console.log('Add Member', {
          selected: this.selected,
          data: data,
        })
        await this.addMember(data)
        this.selected = null
        this.loadMembers()
      } else {
        this.$emit('message', 'Choose a member and/or role')
      }
    },
    remove(data) {
      this.itemId = data.id
      this.actionConfirmRemove = true
    },
    async performRemove() {
      let data = {
        orgid: this.organization.id,
        roleid: this.byRole,
        userid: this.itemId,
      }
      console.log('Remove Member', {
        id: this.itemId,
        data: data,
      })
      await this.removeMember(data)
      this.actionConfirmRemove = null
      this.loadMembers()
    },
    inviteMember() {},
  },
}
</script>
<style lang="scss" scoped>
.custom-wrapper {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 500px;
}
.custom-items-label {
  position: relative;
  font-size: 0.9em;
}
</style>
